import { useState, useEffect } from "react";
import { useUserState } from "./UserContext";

export const useWard = () => {
  const { profile } = useUserState();
  const [selectedWard, setSelectedWard] = useState(() => {
    const stored = localStorage.getItem("selected_ward");

    return stored ? JSON.parse(stored) : null;
  });

  const [wards, setWards] = useState(() => {
    const stored = localStorage.getItem("wards_list");

    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    if (profile?.wards?.length > 0) {
      if (!selectedWard) {
        const firstWard = profile.wards[0];
        setSelectedWard(firstWard);
        setWards(profile.wards);
        localStorage.setItem("selected_ward", JSON.stringify(firstWard));
        localStorage.setItem("wards_list", JSON.stringify(profile.wards));
      } else {
        setWards(profile.wards);
        localStorage.setItem("wards_list", JSON.stringify(profile.wards));

        const wardStillExists = profile.wards.find(w => w.id === selectedWard.id);
        if (!wardStillExists) {
          const firstWard = profile.wards[0];
          setSelectedWard(firstWard);
          localStorage.setItem("selected_ward", JSON.stringify(firstWard));
        }
      }
    }
  }, [profile, selectedWard]);

  const changeWard = (wardId) => {
    const ward = wards.find(w => w.id === wardId);
    if (ward) {
      setSelectedWard(ward);
      localStorage.setItem("selected_ward", JSON.stringify(ward));
    }
  };

  const getCurrentClassId = () => {
    return selectedWard?.class_id;
  };

  const getCurrentStudentId = () => {
    return selectedWard?.id;
  };

  return {
    selectedWard,
    wards,
    changeWard,
    getCurrentClassId,
    getCurrentStudentId
  };
};
